import { render, staticRenderFns } from "./FishHistory.vue?vue&type=template&id=7e47cb49&scoped=true"
import script from "./FishHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./FishHistory.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FishHistory.vue?vue&type=style&index=0&id=7e47cb49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e47cb49",
  null
  
)

export default component.exports